// extracted by mini-css-extract-plugin
export default {"root":"noCountries_root__kH3rq","message":"noCountries_message__b6NCM"};